// types
type Types = any;

const Alert: Types = {
  styleOverrides: {
    standardInfo: {
      backgroundColor: 'rgb(229, 246, 253)',
      color: 'rgb(1, 67, 97)',
      '& .MuiAlert-icon': {
        color: 'rgb(1, 67, 97)'
      }
    }
  }
};

export default Alert;
